import { render, staticRenderFns } from "./symbol-modifier.vue?vue&type=template&id=54397219&scoped=true&"
import script from "./symbol-modifier.vue?vue&type=script&lang=js&"
export * from "./symbol-modifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54397219",
  null
  
)

export default component.exports